import React from 'react';
import type { FC } from 'react';

export enum ITEM_TYPE {
	LINK = 'link',
	MENU = 'menu',
}
type BaseItemType = {
	itemId: string;
	type: ITEM_TYPE;
	title: string;
};
export interface LinkItemType extends BaseItemType {
	type: ITEM_TYPE.LINK;
	link: string;
}
export interface MenuItemType extends BaseItemType {
	type: ITEM_TYPE.MENU;
	childItems?: (MenuItemType | LinkItemType)[];
}
export enum ALIGNMENT {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}
export enum BORDER {
	NONE = 'none',
	ALL_SIDES = 'all_sides',
	TOP_BOTTOM = 'top_bottom',
	TOP = 'top',
	BOTTOM = 'bottom',
}
type Styles = {
	alignment: ALIGNMENT;
	backgroundColor: string;
	borderColor: string;
	border: BORDER;
	textColor: string;
	highlightColor: string;
};
export type LinksMenuParameters = {
	version: string;
	items?: (MenuItemType | LinkItemType)[];
	styles: Styles;
};

type LinksMenuContentProps = {
	parameters: LinksMenuParameters;
	extensionLocalId: string;
	contentId: string;
};

export const LinksMenuContent: FC<LinksMenuContentProps> = ({
	extensionLocalId,
	parameters,
	contentId,
}) => {
	return (
		<div>
			<div>Links menu version {parameters.version}</div>
			<div>rest of params: {JSON.stringify(parameters)}</div>
			<div>
				{extensionLocalId},{contentId}
			</div>
		</div>
	);
};
